import type { Metric } from '@atlassian/browser-metrics/metric';

import { createInteractionMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { COMMENTS_SUMMARY_COMPONENT_INTERACTION } from '@confluence/browser-metrics/entry-points/metric-keys/interactionKey.ts';

export const COMMENTS_SUMMARY_INTERACTION_METRIC: Metric = createInteractionMetric({
	key: COMMENTS_SUMMARY_COMPONENT_INTERACTION,
});
